import { css } from "@emotion/react";
import { breakpoints } from "shared/styles";

const container = css`
  background-color: rgba(0, 0, 0, 0.03);
  padding: 100px 40px;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  column-gap: 20px;
  margin: 0 auto;

  @media ${breakpoints.fromLrg} {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
  }
`;

const caption = css`
  p:not(:last-child) {
    margin-bottom: 20px;
  }

  @media ${breakpoints.fromLrg} {
    width: 40%;
    max-width: 420px;
  }
`;

const heading = css`
  font-weight: 300;
  margin-bottom: 20px;

  @media ${breakpoints.fromLrg} {
    text-align: left;
  }
`;

const image = css`
  align-self: center;
  height: 100%;
  width: 100%;

  @media ${breakpoints.fromMed} {
    height: auto;
    width: 450px;
  }
`;

const clipboardText = css`
  display: flex;
  align-items: center;
  align-self: center;
  gap: 12px;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  border: 1px solid #ccc;
  color: #111827;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 12px;

  &:disabled {
    opacity: 0.3;
  }
`



export default { container, heading, caption, image, clipboardText };
